import React, { useState, memo } from 'react';
import { BookOpen, Users, Award } from 'lucide-react';
const TipsPage = () => {
  const [activeTab, setActiveTab] = useState('theory');
  return <div className="bg-white" data-id="element-1924">
      <div className="container mx-auto px-4 py-12" data-id="element-1925">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1926">Driving Tips</h1>
        <p className="text-gray-700 mb-8" data-id="element-1927">
          Whether you're preparing for your theory test, just passed your
          practical test, or have been driving for years, we've compiled some
          useful tips to help you become a safer and more confident driver.
        </p>
        {/* Tabs */}
        <div className="flex flex-wrap border-b border-gray-200 mb-8" data-id="element-1928">
          <button className={`mr-4 py-2 px-4 font-medium rounded-t-lg ${activeTab === 'theory' ? 'bg-burgundy-600 text-white' : 'text-gray-600 hover:text-burgundy-600'}`} onClick={() => setActiveTab('theory')} data-id="element-1929">
            <div className="flex items-center" data-id="element-1930">
              <BookOpen size={18} className="mr-2" data-id="element-1931" />
              Theory Test Tips
            </div>
          </button>
          <button className={`mr-4 py-2 px-4 font-medium rounded-t-lg ${activeTab === 'new' ? 'bg-burgundy-600 text-white' : 'text-gray-600 hover:text-burgundy-600'}`} onClick={() => setActiveTab('new')} data-id="element-1932">
            <div className="flex items-center" data-id="element-1933">
              <Users size={18} className="mr-2" data-id="element-1934" />
              New Drivers Tips
            </div>
          </button>
          <button className={`py-2 px-4 font-medium rounded-t-lg ${activeTab === 'experienced' ? 'bg-burgundy-600 text-white' : 'text-gray-600 hover:text-burgundy-600'}`} onClick={() => setActiveTab('experienced')} data-id="element-1935">
            <div className="flex items-center" data-id="element-1936">
              <Award size={18} className="mr-2" data-id="element-1937" />
              Experienced Drivers Tips
            </div>
          </button>
        </div>
        {/* Content */}
        <div className="mb-12" data-id="element-1938">
          {activeTab === 'theory' && <div data-id="element-1939">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1940">Theory Test Tips</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-1941">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1942">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-1943">
                    Multiple Choice Questions
                  </h3>
                  <ul className="space-y-2" data-id="element-1944">
                    <li className="flex items-start" data-id="element-1945">
                      <div className="text-burgundy-600 mr-2" data-id="element-1946">•</div>
                      <div data-id="element-1947">
                        Study the Highway Code thoroughly - it forms the basis
                        of many questions.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1948">
                      <div className="text-burgundy-600 mr-2" data-id="element-1949">•</div>
                      <div data-id="element-1950">
                        Use official DVSA practice materials and apps to
                        familiarise yourself with the question format.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1951">
                      <div className="text-burgundy-600 mr-2" data-id="element-1952">•</div>
                      <div data-id="element-1953">
                        Create a study schedule and stick to it - consistent
                        practice is key.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1954">
                      <div className="text-burgundy-600 mr-2" data-id="element-1955">•</div>
                      <div data-id="element-1956">
                        Focus on traffic signs and road markings, as these
                        frequently appear in the test.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1957">
                      <div className="text-burgundy-600 mr-2" data-id="element-1958">•</div>
                      <div data-id="element-1959">
                        Don't just memorise answers - understand the reasoning
                        behind them.
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1960">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-1961">
                    Hazard Perception
                  </h3>
                  <ul className="space-y-2" data-id="element-1962">
                    <li className="flex items-start" data-id="element-1963">
                      <div className="text-burgundy-600 mr-2" data-id="element-1964">•</div>
                      <div data-id="element-1965">
                        Practise spotting developing hazards - click when you
                        first see a potential danger.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1966">
                      <div className="text-burgundy-600 mr-2" data-id="element-1967">•</div>
                      <div data-id="element-1968">
                        Avoid clicking too many times in quick succession, as
                        this can be flagged as cheating.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1969">
                      <div className="text-burgundy-600 mr-2" data-id="element-1970">•</div>
                      <div data-id="element-1971">
                        Look for clues like pedestrians near the road, children
                        playing, or vehicles signalling.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1972">
                      <div className="text-burgundy-600 mr-2" data-id="element-1973">•</div>
                      <div data-id="element-1974">
                        Remember that each clip contains at least one developing
                        hazard.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1975">
                      <div className="text-burgundy-600 mr-2" data-id="element-1976">•</div>
                      <div data-id="element-1977">
                        Use official DVSA hazard perception practice tests to
                        get familiar with the format.
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1978">
                <h3 className="text-xl font-semibold mb-3" data-id="element-1979">On Test Day</h3>
                <ul className="space-y-2" data-id="element-1980">
                  <li className="flex items-start" data-id="element-1981">
                    <div className="text-burgundy-600 mr-2" data-id="element-1982">•</div>
                    <div data-id="element-1983">Get a good night's sleep before your test.</div>
                  </li>
                  <li className="flex items-start" data-id="element-1984">
                    <div className="text-burgundy-600 mr-2" data-id="element-1985">•</div>
                    <div data-id="element-1986">
                      Arrive at the test centre at least 15 minutes early with
                      your provisional licence and booking reference.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-1987">
                    <div className="text-burgundy-600 mr-2" data-id="element-1988">•</div>
                    <div data-id="element-1989">
                      Read each question carefully and consider all options
                      before answering.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-1990">
                    <div className="text-burgundy-600 mr-2" data-id="element-1991">•</div>
                    <div data-id="element-1992">
                      If you're unsure about a question, flag it and return to
                      it later.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-1993">
                    <div className="text-burgundy-600 mr-2" data-id="element-1994">•</div>
                    <div data-id="element-1995">
                      Manage your time carefully - you have 57 minutes for the
                      multiple-choice section.
                    </div>
                  </li>
                </ul>
              </div>
            </div>}
          {activeTab === 'new' && <div data-id="element-1996">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1997">New Drivers Tips</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-1998">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1999">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-2000">
                    Building Confidence
                  </h3>
                  <ul className="space-y-2" data-id="element-2001">
                    <li className="flex items-start" data-id="element-2002">
                      <div className="text-burgundy-600 mr-2" data-id="element-2003">•</div>
                      <div data-id="element-2004">
                        Start with short, familiar journeys to build your
                        confidence gradually.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2005">
                      <div className="text-burgundy-600 mr-2" data-id="element-2006">•</div>
                      <div data-id="element-2007">
                        Drive during daylight and good weather conditions
                        initially.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2008">
                      <div className="text-burgundy-600 mr-2" data-id="element-2009">•</div>
                      <div data-id="element-2010">
                        Consider taking a Pass Plus course to develop your
                        skills further.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2011">
                      <div className="text-burgundy-600 mr-2" data-id="element-2012">•</div>
                      <div data-id="element-2013">
                        Drive solo to develop your own decision-making
                        abilities.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2014">
                      <div className="text-burgundy-600 mr-2" data-id="element-2015">•</div>
                      <div data-id="element-2016">
                        Remember that building confidence takes time - don't
                        rush yourself.
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-2017">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-2018">Safety First</h3>
                  <ul className="space-y-2" data-id="element-2019">
                    <li className="flex items-start" data-id="element-2020">
                      <div className="text-burgundy-600 mr-2" data-id="element-2021">•</div>
                      <div data-id="element-2022">
                        Always adjust your mirrors and seat before setting off.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2023">
                      <div className="text-burgundy-600 mr-2" data-id="element-2024">•</div>
                      <div data-id="element-2025">
                        Avoid distractions - set up your navigation and music
                        before starting your journey.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2026">
                      <div className="text-burgundy-600 mr-2" data-id="element-2027">•</div>
                      <div data-id="element-2028">
                        Never use your phone while driving - it's illegal and
                        dangerous.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2029">
                      <div className="text-burgundy-600 mr-2" data-id="element-2030">•</div>
                      <div data-id="element-2031">
                        Be aware of the New Driver Act - you'll lose your
                        licence if you get 6 points within 2 years of passing.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2032">
                      <div className="text-burgundy-600 mr-2" data-id="element-2033">•</div>
                      <div data-id="element-2034">
                        Leave plenty of space between you and the vehicle in
                        front.
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-2035">
                <h3 className="text-xl font-semibold mb-3" data-id="element-2036">Practical Advice</h3>
                <ul className="space-y-2" data-id="element-2037">
                  <li className="flex items-start" data-id="element-2038">
                    <div className="text-burgundy-600 mr-2" data-id="element-2039">•</div>
                    <div data-id="element-2040">
                      Learn basic car maintenance like checking oil, water, and
                      tyre pressure.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2041">
                    <div className="text-burgundy-600 mr-2" data-id="element-2042">•</div>
                    <div data-id="element-2043">
                      Consider taking a motorway driving lesson with an
                      instructor, as this isn't covered in the standard test.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2044">
                    <div className="text-burgundy-600 mr-2" data-id="element-2045">•</div>
                    <div data-id="element-2046">
                      Plan unfamiliar journeys in advance and allow extra time.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2047">
                    <div className="text-burgundy-600 mr-2" data-id="element-2048">•</div>
                    <div data-id="element-2049">
                      Keep a small emergency kit in your car (torch, blanket,
                      water, etc.).
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2050">
                    <div className="text-burgundy-600 mr-2" data-id="element-2051">•</div>
                    <div data-id="element-2052">
                      Shop around for insurance - consider black box policies
                      which can reduce premiums for safe driving.
                    </div>
                  </li>
                </ul>
              </div>
            </div>}
          {activeTab === 'experienced' && <div data-id="element-2053">
              <h2 className="text-2xl font-bold mb-4" data-id="element-2054">
                Experienced Drivers Tips
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-2055">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-2056">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-2057">
                    Refreshing Your Skills
                  </h3>
                  <ul className="space-y-2" data-id="element-2058">
                    <li className="flex items-start" data-id="element-2059">
                      <div className="text-burgundy-600 mr-2" data-id="element-2060">•</div>
                      <div data-id="element-2061">
                        Consider a refresher lesson if you haven't driven for a
                        while.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2062">
                      <div className="text-burgundy-600 mr-2" data-id="element-2063">•</div>
                      <div data-id="element-2064">
                        Stay updated with changes to the Highway Code - they
                        happen more often than you might think.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2065">
                      <div className="text-burgundy-600 mr-2" data-id="element-2066">•</div>
                      <div data-id="element-2067">
                        Practise advanced manoeuvres like parallel parking in a
                        quiet area if you're rusty.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2068">
                      <div className="text-burgundy-600 mr-2" data-id="element-2069">•</div>
                      <div data-id="element-2070">
                        Consider an advanced driving course like IAM RoadSmart
                        or RoSPA.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2071">
                      <div className="text-burgundy-600 mr-2" data-id="element-2072">•</div>
                      <div data-id="element-2073">
                        Regularly check for bad habits that may have crept into
                        your driving style.
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-2074">
                  <h3 className="text-xl font-semibold mb-3" data-id="element-2075">
                    Defensive Driving
                  </h3>
                  <ul className="space-y-2" data-id="element-2076">
                    <li className="flex items-start" data-id="element-2077">
                      <div className="text-burgundy-600 mr-2" data-id="element-2078">•</div>
                      <div data-id="element-2079">
                        Anticipate other road users' actions - expect the
                        unexpected.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2080">
                      <div className="text-burgundy-600 mr-2" data-id="element-2081">•</div>
                      <div data-id="element-2082">
                        Maintain a safe following distance (at least 2 seconds,
                        more in poor conditions).
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2083">
                      <div className="text-burgundy-600 mr-2" data-id="element-2084">•</div>
                      <div data-id="element-2085">
                        Regularly check your mirrors and be aware of your blind
                        spots.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2086">
                      <div className="text-burgundy-600 mr-2" data-id="element-2087">•</div>
                      <div data-id="element-2088">
                        Stay calm in challenging situations - road rage helps no
                        one.
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-2089">
                      <div className="text-burgundy-600 mr-2" data-id="element-2090">•</div>
                      <div data-id="element-2091">
                        Always have an escape route planned in case of
                        emergency.
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-2092">
                <h3 className="text-xl font-semibold mb-3" data-id="element-2093">
                  Long-Term Driving Health
                </h3>
                <ul className="space-y-2" data-id="element-2094">
                  <li className="flex items-start" data-id="element-2095">
                    <div className="text-burgundy-600 mr-2" data-id="element-2096">•</div>
                    <div data-id="element-2097">
                      Have regular eye tests to ensure your vision meets driving
                      standards.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2098">
                    <div className="text-burgundy-600 mr-2" data-id="element-2099">•</div>
                    <div data-id="element-2100">
                      Take breaks on long journeys - at least 15 minutes every
                      two hours.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2101">
                    <div className="text-burgundy-600 mr-2" data-id="element-2102">•</div>
                    <div data-id="element-2103">
                      Maintain good posture while driving to prevent back
                      problems.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2104">
                    <div className="text-burgundy-600 mr-2" data-id="element-2105">•</div>
                    <div data-id="element-2106">
                      Consider eco-driving techniques to save fuel and reduce
                      environmental impact.
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-2107">
                    <div className="text-burgundy-600 mr-2" data-id="element-2108">•</div>
                    <div data-id="element-2109">
                      Keep your vehicle well-maintained with regular servicing.
                    </div>
                  </li>
                </ul>
              </div>
            </div>}
        </div>
        <div className="text-center" data-id="element-2110">
          <h2 className="text-2xl font-bold mb-4" data-id="element-2111">
            Need More Specific Advice?
          </h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-2112">
            Our instructors are always happy to provide personalised tips and
            guidance. Whether you're preparing for your test or looking to
            improve specific driving skills, we're here to help.
          </p>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" data-id="element-2113">
            Contact Us
          </a>
        </div>
      </div>
    </div>;
};
export default TipsPage;